/* eslint-disable no-console */
import { GenericAnalyticsDestination } from '../types';

class DebugDestination
    implements GenericAnalyticsDestination<'debug', undefined>
{
    public name: 'debug';
    public raw: undefined;
    private isInitialized: boolean;
    static logPrefix = 'Analytics Debug';

    constructor() {
        this.name = 'debug';
        this.isInitialized = false;
    }

    private getPrefix() {
        return `${DebugDestination.logPrefix}:${
            this.isInitialized ? '' : ' [Untracked] '
        }`;
    }

    public init(...props: any[]): Promise<void> {
        this.isInitialized = true;
        console.info(
            `${DebugDestination.logPrefix} init (flushes all [Untracked] events)`,
            {
                props,
            }
        );
        return Promise.resolve();
    }

    public track(
        event: string,
        properties?: Record<string, any>
    ): Promise<void> {
        console.info(`${this.getPrefix()} track`, {
            event,
            properties,
        });
        return Promise.resolve();
    }

    public flush(): Promise<void> {
        console.info(`${this.getPrefix()} flush`);
        return Promise.resolve();
    }

    public reset() {
        console.info(`${this.getPrefix()} reset`);
    }

    public identify(uuid: string): Promise<void> {
        console.info(`${this.getPrefix()} identify`, { uuid });
        return Promise.resolve();
    }

    public setUserProperties(props: Record<string, any>): Promise<void> {
        console.info(`${this.getPrefix()} setUserProperties`, {
            props,
        });
        return Promise.resolve();
    }

    public register(props: Record<string, any>): Promise<void> {
        console.info(`${this.getPrefix()} register`, {
            props,
        });
        return Promise.resolve();
    }

    public isLoaded() {
        return true;
    }
}

export function createDebugDestination(): DebugDestination {
    return new DebugDestination();
}
